import { useQuery } from 'react-query';
import { client } from '../client';

const useBlogs = () => {
  const response = useQuery('blogs', () =>
    client
      .getEntries({
        content_type: 'post',
      })
      .then((data) => data.items));
  return { ...response, blogs: response.data };
};

const useBlogPost = (slug) => {
  const response = useQuery(['blogs', slug], () =>
    client
      .getEntries({
        content_type: 'post',

        limit: 1,
        'fields.slug[in]': slug,

      })
      .then((data) => data.items));

  return { ...response, blogPost: response.data };
};

export { useBlogs, useBlogPost };
